import React from 'react';
import { DataGrid, GridFooter, GridToolbar } from '@mui/x-data-grid';
import CustomFooterTotal from './CustomFooterTotal';
import { Box } from '@mui/material';
import CustomToolbar from './CustomToolbar';


export default function RequestReportGrid({ xRows, xColumns, xIsMIS = false }) {
    console.log(xColumns);
    return (
        <Box sx={{ height: '100%', width: '100%' }}>
            <DataGrid
                rows={xRows}
                // getRowId={(row) => row.SrNo}
                columns={xColumns}
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            // Hide columns status and traderName, the other columns will remain visible
                            B_ItmCd: false,
                            Vendorname: false,
                            B_NetAmt: false,
                            A_DCStatus: false,
                            B_Pick_Qty: false,
                            A_PickStatus: false
                        },
                    },
                }}
                rowHeight={30}
                headerHeight={60}
                sx={{
                    border: 0,
                    borderColor: 'primary.light',
                    boxShadow: 'rgba(0, 0, 0, 0.35) 0px 5px 15px',
                    '& .MuiDataGrid-row:hover': {
                        color: 'primary.main',
                        cursor: 'pointer',
                        fontWeight: 500,
                        // backgroundColor: '#ebeef0',
                        //boxShadow: 'rgba(0, 0, 0, 0.35) 10px 15px 15px'
                    },

                }}
                components={{
                    Toolbar: GridToolbar,
                    Footer: xIsMIS ? CustomFooterTotal : GridFooter

                }}
                componentsProps={{
                    footer: { rows: xRows },
                    filterPanel: { sx: { maxWidth: "93vw" } }

                }}
                // getRowClassName={(params) =>
                //     params.indexRelativeToCurrentPage % 2 === 0 ? 'mui-report-grid-even-row' : 'mui-report-grid-odd-row'
                // }
                getRowClassName={(params) =>
                    'mui-report-grid-row'
                }

            />
        </Box>
    )
}
